/** @jsxImportSource @emotion/core */
import { css } from '@emotion/core';
import React from 'react';

import Text from 'components/styled/Text';
import { ListItem, UnorderedList } from 'components/styled/List';

export const SkillGroup: React.FC = ({ children }) => (
	<UnorderedList mt={0}>{children}</UnorderedList>
);

export const SkillBox: React.FC = ({ children }) => (
	<ListItem
		css={css`
			display: flex;
			align-items: center;
		`}
	>
		{children}
	</ListItem>
);
// export const SkillBox = Chip;

export const SkillTitle: React.FC<React.ComponentProps<typeof Text>> = ({
	children,
	...textProps
}) => (
	<Text
		as="span"
		css={css`
			/* white-space: wrap; */
		`}
		{...textProps}
	>
		{children}
	</Text>
);
